<template>
<v-layout wrap>
  <v-flex xs12>
    <v-card>
      <v-toolbar card>
        <v-toolbar-title>
          <v-btn flat icon @click="$_getPrevReports()">
            <v-icon dark>keyboard_arrow_left</v-icon>
          </v-btn>
          {{calendarTitle}}
          <v-btn flat icon @click="$_getNextReports()">
            <v-icon dark>keyboard_arrow_right</v-icon>
          </v-btn>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-select
          v-model="selectedItemId"
          :items="selectItems"
          item-value="id"
          item-text="name"
          :label="selectorLabel"
          :loading="selectItemsLoading"
          ref="selector">
          <!--
          <template v-slot:prepend-item>
            <v-list-tile @click="selectedItemId = null;$refs.selector.blur()">전체</v-list-tile>
            <v-divider></v-divider>
          </template>
          -->
        </v-select>
        <v-btn flat icon>
          <v-icon @click="$_toggleViewType()">{{viewTypeIcon}}</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-progress-linear v-show="loading" color="blue" indeterminate height="2" style="margin : 0 auto ;" ></v-progress-linear>
      <v-sheet>
        <report-monthly-calendar
          v-if="viewType === 'calendar'"
          ref="calendar"
          :reports="reports"
          :initStart="start"
          />

        <report-monthly-list
          v-else-if="viewType === 'list' && kind === 'checker'"
          :reports="reports"
          :initStart="start" />

        <report-monthly-attendance
          v-else-if="viewType === 'attendance' && kind === 'checker'"
          :reports="reports"
          :initStart="start" />

        <report-monthly-data-table
          v-else-if="viewType === 'data_table' || (viewType === 'list' && (kind === 'place' || kind === 'charger'))"
          :reports="reports" />

      </v-sheet>
    </v-card>
  </v-flex>
</v-layout>
</template>

<script>
import firebase from 'firebase/compat/app'
// import 'firebase/compat/firestore'
import 'firebase/compat/storage'
import moment from 'moment'
import ReportMonthlyCalendar from './ReportMonthlyCalendar'
import ReportMonthlyDataTable from './ReportMonthlyDataTable'
import ReportMonthlyList from './ReportMonthlyList'
import ReportMonthlyAttendance from './Attendance/ReportMonthlyAttendance'

const KIND_CHECKER = 'checker'
const KIND_PLACE = 'place'
const KIND_CHARGER = 'charger'
const VIEW_TYPE_CALENDAR = 'calendar'
const VIEW_TYPE_DATA_TABLE = 'data_table'
const VIEW_TYPE_LIST = 'list'
const VIEW_TYPE_ATTENDANCE = 'attendance'

export default {
  name: 'ReportMonthlyList',
  components: {
    'report-monthly-calendar': ReportMonthlyCalendar,
    'report-monthly-data-table': ReportMonthlyDataTable,
    'report-monthly-list': ReportMonthlyList,
    'report-monthly-attendance': ReportMonthlyAttendance
  },
  props: {
    kind: {
      type: String,
      default () {
        return KIND_CHECKER
      }
    }
  },
  data () {
    return {
      start: moment().startOf('month').format('YYYY-MM-DD'),
      end: moment().startOf('month').add(5, 'days').format('YYYY-MM-DD'),
      reports: [],
      selectItems: [],
      loading: false,
      selectItemsLoading: false,
      selectedItemId: null,
      viewType: VIEW_TYPE_CALENDAR
    }
  },
  watch: {
    '$route' (to, from) {
      this.$_getReports()
    },
    start (to, from) {
      // console.log('start', _old + ' -> ' + _new, moment(_new).startOf('month').startOf('week').format('YYYY-MM-DD'))
      this.$_getReports()
    },
    selectedItemId (to, from) {
      this.$_getReports()
    },
    reports (to, from) {
      // console.log(to.length, from.length)
    },
    kind (to, from) {
      if (to === KIND_CHECKER) {
        this.$emit('title', '근태기록')
        this.$_getCheckers()
      } else if (to === KIND_PLACE) {
        this.$emit('title', '충전소점검기록')
        this.$_getPlaces()
      } else if (to === KIND_CHARGER) {
        this.$emit('title', '충전기점검기록')
        this.$_getChargers()
      }

      this.selectedItemId = null
    }
  },
  computed: {
    calendarTitle () {
      return moment(this.start).format('YYYY-MM')
    },
    selectorLabel () {
      if (this.kind === KIND_CHECKER) {
        return '점검자를 선택하세요.'
      } else if (this.kind === KIND_PLACE) {
        return '충전소를 선택하세요.'
      } else if (this.kind === KIND_CHARGER) {
        return '충전기를 선택하세요.'
      }
    },
    viewTypeIcon () {
      return this.viewType === VIEW_TYPE_DATA_TABLE ? 'event' : 'list'
    }
  },
  created () {
    this.$_getReports()

    if (this.kind === KIND_CHECKER) {
      this.$emit('title', '근태기록')
      this.$_getCheckers()
    } else if (this.kind === KIND_PLACE) {
      this.$emit('title', '충전소점검기록')
      this.$_getPlaces()
    } else if (this.kind === KIND_CHARGER) {
      this.$emit('title', '충전기점검기록')
      this.$_getChargers()
    }
    // alert(this.start + " : " + this.end)
  },
  methods: {
    $_getPrevReports () {
      if (this.viewType === VIEW_TYPE_CALENDAR) {
        this.$refs.calendar.prev()
      }

      this.start = moment(this.start, 'YYYY-MM').subtract(1, 'month').format('YYYY-MM')
    },
    $_getNextReports () {
      if (this.viewType === VIEW_TYPE_CALENDAR) {
        this.$refs.calendar.next()
      }

      this.start = moment(this.start, 'YYYY-MM').add(1, 'month').format('YYYY-MM')
    },
    async $_getReports () {
      this.loading = true
      this.reports = []

      let query = this.$fs.collection('reports')

      if (this.selectedItemId) {
        if (this.kind === KIND_CHECKER) {
          query = query.where('checkerRef',
            '==',
            this.$fs.collection('checkers').doc(this.selectedItemId))
        } else if (this.kind === KIND_PLACE) {
          query = query.where('placeRef',
            '==',
            this.$fs.collection('places').doc(this.selectedItemId))
        } else if (this.kind === KIND_CHARGER) {
          query = query.where('chargerRef',
            '==',
            this.$fs.collection('chargers').doc(this.selectedItemId))
        }
      } else {
        this.loading = false
        return // selectedItemId 가 없으면 쿼리 안함
      }

      query
        .where('created', '>=', moment(this.start).startOf('month').toDate())
        .where('created', '<=', moment(this.start).endOf('month').toDate())
        // .where('created', '>=', moment(this.start).startOf('month').startOf('week').toDate())
        // .where('created', '<=', moment(this.start).endOf('month').endOf('week').toDate())
        .get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            // console.log(`${doc.id} => ${doc.data()}`)

            var item = doc.data()
            item.id = doc.id
            item.date = moment(item.created.toDate()).format('YYYY-MM-DD')
            item.pictureUrls = []

            if (item.pictures && item.pictures.length > 0) {
              for (var i = 0; i < item.pictures.length; i++) {
                firebase.storage().ref(item.pictures[i]).getDownloadURL()
                  .then((result) => {
                    item.pictureUrls.push(result)
                  }).catch(error => {
                    if (error) {
                      // TODO 오류 처리
                    }
                    // console.log('error', error)
                  })
              }
            }

            this.reports.push(item)

            // this.datas.push({ divider: true, inset: false })
          })

          this.loading = false
        }).catch(error => {
          if (error) {
            // TODO 오류 처리
            console.log(error)
          }
          this.loading = false
        })
    },
    $_getCheckers () {
      this.selectItemsLoading = true
      this.selectItems = []

      this.$fs.collection('checkers')
        .where('group', '==', this.$store.state.session.group)
        .orderBy('name')
        .get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            // console.log(`${doc.id} => ${doc.data()}`)

            var item = doc.data()
            item.id = doc.id
            this.selectItems.push(item)
            // this.datas.push({ divider: true, inset: false })
            // console.log(doc.data())
          })

          this.selectItemsLoading = false
        }).catch(error => {
          if (error) {
            // TODO 오류 처리
          }
          this.selectItemsLoading = false
        })
    },
    $_getPlaces () {
      this.selectItemsLoading = true
      this.selectItems = []

      this.$fs.collection('places')
        .where('group', '==', this.$store.state.session.group)
        .orderBy('name')
        .get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            // console.log(`${doc.id} => ${doc.data()}`)

            var item = doc.data()
            item.id = doc.id
            this.selectItems.push(item)
            // this.datas.push({ divider: true, inset: false })
            // console.log(doc.data())
          })

          this.selectItemsLoading = false
        }).catch(error => {
          if (error) {
            // TODO 오류 처리
          }
          this.selectItemsLoading = false
        })
    },
    $_getChargers () {
      this.selectItemsLoading = true
      this.selectItems = []

      this.$fs.collection('places')
        .where('group', '==', this.$store.state.session.group)
        .orderBy('name')
        .get()
        .then((querySnapshot) => {
          const placeNames = new Map()

          querySnapshot.forEach((doc) => {
            var item = doc.data()
            item.id = doc.id

            placeNames.set(item.id, item.name)
          })

          this.$fs.collection('chargers')
            .where('group', '==', this.$store.state.session.group)
            .orderBy('managementNumber')
            .get().then((querySnapshot) => {
              const selectItems = []

              querySnapshot.forEach((doc) => {
                var item = doc.data()
                item.id = doc.id

                if (item.placeRef) {
                  let placeName = placeNames.get(item.placeRef.id)
                  item.name = `${placeName} - ${item.managementNumber}`
                  selectItems.push(item)
                }

                // this.datas.push({ divider: true, inset: false })
                // console.log(doc.data())
              })

              selectItems.sort((a, b) => {
                var nameA = a.name.toUpperCase() // ignore upper and lowercase
                var nameB = b.name.toUpperCase() // ignore upper and lowercase
                if (nameA < nameB) {
                  return -1
                }
                if (nameA > nameB) {
                  return 1
                }

                // 이름이 같을 경우
                return 0
              })
              // console.log(selectItems)
              this.selectItems = selectItems

              this.selectItemsLoading = false
            })
            .catch(error => {
              if (error) {
                // TODO 오류 처리
                console.log(error)
              }
              this.selectItemsLoading = false
            })
        })
        .catch(error => {
          if (error) {
            // TODO 오류 처리
            console.log(error)
          }
          this.selectItemsLoading = false
        })
    },
    $_toggleViewType () {
      if (this.kind === KIND_CHECKER) {
        if (this.viewType === VIEW_TYPE_CALENDAR) {
          this.viewType = VIEW_TYPE_LIST
        } else if (this.viewType === VIEW_TYPE_LIST) {
          this.viewType = VIEW_TYPE_ATTENDANCE
        } else {
          this.viewType = VIEW_TYPE_CALENDAR
        }
        // VIEW_TYPE_ATTENDANCE
      } else {
        if (this.viewType === VIEW_TYPE_CALENDAR) {
          this.viewType = VIEW_TYPE_LIST
        } else {
          this.viewType = VIEW_TYPE_CALENDAR
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Report/ReportMonthly.vue